import { Trans } from '@lingui/react/macro'
import { Card, Skeleton } from '@tecsinapse/cortex-react'
import React from 'react'
import {
  ItemBiblioteca,
  UltimosModificadosQueryGqlQuery
} from '@/core/types/graphql'
import { ItemArquivoBibliotecaCard } from './item-arquivo-biblioteca-card'

interface ItensRecentesDisplayCortexProps {
  dataArquivosRecentes?: UltimosModificadosQueryGqlQuery
  loading: boolean
  isRoot: boolean
}

export const ItensRecentesDisplay = ({
  dataArquivosRecentes,
  loading,
  isRoot
}: ItensRecentesDisplayCortexProps) => {
  const { ultimosModificados = [] } = dataArquivosRecentes ?? {}
  if (!isRoot || (!loading && (ultimosModificados ?? []).length === 0)) {
    return null
  }

  if (loading) {
    return <Skeleton className='h-28 w-full rounded-mili mb-deca' />
  }

  return (
    <Card className='space-y-kilo mb-deca'>
      <div className='flex flex-row items-center justify-between'>
        <p className='text-h3 text-secondary-xdark font-bold'>
          <Trans>Arquivos recentes</Trans>
        </p>
      </div>
      <div className='grid grid-cols-1 sm:grid-cols-3 gap-x-deca gap-y-deca'>
        {(ultimosModificados ?? []).map((itemBiblioteca, index) => {
          if (index >= 3) return null
          return (
            <ItemArquivoBibliotecaCard
              key={itemBiblioteca?.id}
              item={itemBiblioteca as ItemBiblioteca}
              isRecentFiles
            />
          )
        })}
      </div>
    </Card>
  )
}
